/**********************************************************
 * Page
 **********************************************************/
import { frw, uic } from '@sfidanza/tahr';
import { scoreEditor } from './scoreEditor.js';
import { bet } from './bet.js';
import { live } from './live.js';
import { config } from './config.js';

export const page = {
	data: {},
	config: config,
	scoreEditor: scoreEditor,
	bet: bet,
	live: live
};
window.page = page; // make page callable from global scope so it can be used from html

page.initialize = function () {
	// compute which competition to retrieve
	page.config.year = page.getYear();
	page.config.cid = page.config.getCompetitionId(page.config.year);
	page.config.name = page.config.i18n.names[page.config.cid](page.config.year);

	// retrieve templates and data
	page.notify('Loading data...', true);
	Promise.all([
		frw.ssa.loadTemplates(page.config.url.templates, page.templates, page.config.i18n, page),
		page.getData()
	]).then(() => {
		// Initialize history
		frw.history.initialize(page.select.bind(page));

		// Set pageTitle function
		page.config.i18n.pageTitle = page.config.i18n.title.bind(null, page.config.name);

		// display
		page.templates.main.parse(page.config.year);
		page.templates.main.load(page.config.area.main);

		page.templates.user.parse(page.data);
		page.templates.user.load(page.config.area.user);
		page.scoreEditor.initialize(page, frw);
		page.bet.initialize(page);
		page.live.initialize({ url: page.config.url.live }, page);

		this.loginDlg = new uic.Dialog({
			id: page.config.area.loginDlg,
			centered: true
		});
		this.tooltip = new uic.Tooltip(0);

		page.select(frw.history.getCurrentState() || page.config.defaultPage);
		page.notify(null);
	});
};

page.destroy = function () {
	this.loginDlg.destroy();
	this.tooltip.destroy();
	this.pwl = null;
	for (const id in page.templates) {
		const tpl = page.templates[id];
		if (tpl.destroy) tpl.destroy();
	}

	page.scoreEditor.destroy();
	page.bet.destroy();
};

page.getYear = function () {
	let year = location.pathname.slice(1);
	if (!/^\d{4}$/.test(year)) {
		year = page.config.defaultYear;
	}
	return year;
};

page.notify = function (message, init) {
	if (!this.pwl) this.pwl = document.getElementById(page.config.area.pwl);
	if (message) {
		this.pwl.innerHTML = message;
	} else {
		this.pwl.innerHTML = '';
		this.pwl.style.display = 'none';
	}
	if (init) {
		this.pwl.style.display = 'block';
		frw.dom.center(this.pwl);
	}
};

page.getData = async function () {
	return fetch(page.config.url.data(page.config.year))
		.then(response => response.json())
		.then(data => {
			data.stadiums = frw.data.indexBy(data.stadiums, 'id');
			if (!data.teams || data.teams.length === 0) {
				const teamsById = {};
				const matches = data.matches.some(m => m.group) ? data.matches.filter(m => m.group) : data.matches;
				matches.forEach(m => {
					if (!teamsById[m.team1_id]) {
						teamsById[m.team1_id] = { id: m.team1_id, name: m.team1_name, group: m.group };
					}
					if (!teamsById[m.team2_id]) {
						teamsById[m.team2_id] = { id: m.team2_id, name: m.team2_name, group: m.group };
					}
				});
				data.teams = Object.values(teamsById);
			}
			if (!data.stadiums) {
				data.stadiums = {};
				data.matches.forEach(m => {
					if (m.stadium && !data.stadiums[m.stadium]) {
						data.stadiums[m.stadium] = { id: m.stadium, name: m.stadium_name, city: m.stadium_city };
					}
				});
			}
			page.data = data;
		});
};

page.updateMatch = function (match) {
	// Dynamically create a container for a new live
	let container = document.querySelector(`[data-live-match="${match.fid}"]`);
	if (!container) {
		container = document.createElement('div');
		container.setAttribute('data-live-match', match.fid);
		document.getElementById(page.config.area.liveMatch).appendChild(container);
	}
	page.templates.liveMatch.parse(match);
	page.templates.liveMatch.load(container);

	const m = page.data.matches.find(it => it.fid === match.fid);
	if (m) {
		m.team1_score = match.team1_score;
		m.team2_score = match.team2_score;
		m.team1_scorePK = match.team1_scorePK;
		m.team2_scorePK = match.team2_scorePK;
		m.live = match.live;

		const matchElement = document.querySelector(`[data-match="${match.fid}"]`);
		if (matchElement) {
			if (match.team1_score != null) {
				const pso = (match.team1_scorePK != null) ?
					'<br/><span class="pso">(' + match.team1_scorePK + ' - ' + match.team2_scorePK + ')</span>' : '';
				matchElement.querySelector('.score').innerHTML = match.team1_score + ' - ' + match.team2_score + pso;
			}
			matchElement.dataset.live = match.live;
		}
	}
};

page.register = function (login, cb) {
	fetch(page.config.url.register, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(login)
	})
		.then(response => response.json())
		.then(data => {
			page.refreshUser(data, cb);
		});
};

page.login = function (login, cb) {
	fetch(page.config.url.login, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(login)
	})
		.then(response => response.json())
		.then(data => {
			page.refreshUser(data, cb);
		});
};

page.logout = function () {
	fetch(page.config.url.logout, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' }
	})
		.then(response => response.json())
		.then(data => {
			page.refreshUser(data);
		});
};

page.refreshUser = function (data, cb) {
	page.data.user = data && data.user;

	//	page.templates.main.parse(); // BREAKS!! Only bets depend on user - review solution!
	//	page.templates.main.load(page.config.area.main);

	page.templates.user.parse(data || {});
	page.templates.user.load(page.config.area.user);

	if (this.current === 'bet') {
		page.redrawView();
	}
	if (cb) cb();
};

page.getPageTitle = function (stateTitle) {
	return page.config.i18n.pageTitle(stateTitle);
};

page.getMenuItem = function (hash) {
	return document.querySelector(`a[href='${hash}']`);
};

page.highlight = function (link) {
	document.querySelectorAll('a.selected').forEach(item => {
		item.className = '';
	});
	link.className = 'selected';
	link.blur();
};

page.select = function (link, event) {
	if (event) event.preventDefault();

	let target;
	if (typeof link === 'string') {
		target = link;
		link = page.getMenuItem('#' + target);
	} else {
		target = link.href.split('#')[1];
	}
	if (target) {
		if (link) {
			page.highlight(link);
			frw.history.pushState(target, page.getPageTitle(link.title || link.innerHTML));
		}
		page.view(target);
		this.current = target;
	}
};

page.redrawView = function () {
	page.view(this.current);
};

page.view = function (viewName) {
	page.scoreEditor.unplug();
	page.show(...viewName.split(','));
};

page.show = function (viewName, ...option) {
	switch (viewName) {
		case 'schedule': page.showSchedule(...option); break;
		case 'group': page.showGroup(...option); break;
		case 'board': page.showBoard(); break;
		case 'board32': page.showBoard32(); break;
		case 'bestThirds': page.showBestThirds(); break;
		case 'history': page.showPage('history', ...option); break;
		case 'notes': page.showPage('notes'); break;
		case 'login': page.showPage('login', ...option); break;
		case 'register': page.showPage('register', ...option); break;
		case 'bet': page.showPage('bet', ...option); break;
	}
	document.getElementById(page.config.area.contents).className = 'page-' + viewName;
};

page.showSchedule = function (phase) {
	const matches = (phase == 1) ? page.data.matches.filter(m => m.phase == 'G') :
		((phase == 2) ? page.data.matches.filter(m => m.group == null) : page.data.matches);

	const data = {
		teams: page.data.teams,
		matches: matches,
		stadiums: page.data.stadiums
	};

	page.templates.schedule.parse(data);
	page.templates.schedule.load(page.config.area.contents);
	page.scoreEditor.plug();
};

page.showGroup = function (group) {
	if (group) {
		this.activeGroup = group;
	} else {
		group = this.activeGroup || 'A';
	}
	const data = {
		teams: page.data.teams.filter(item => item.group === group),
		matches: page.data.matches.filter(item => item.group === group),
		stadiums: page.data.stadiums
	};

	page.templates.ranking.parse(data.teams, group);
	page.templates.schedule.parse(data);
	const content = [
		page.templates.ranking.retrieve(),
		page.templates.schedule.retrieve()
	].join('\n');
	frw.dom.updateContainer(content, document.getElementById(page.config.area.contents));
	page.templates.ranking.onLoad();
	page.templates.schedule.onLoad();
	page.scoreEditor.plug();
};

page.showBoard = function () {
	const data = {
		teams: page.data.teams,
		matches: page.data.matches.filter(m => m.group == null),
		stadiums: page.data.stadiums
	};

	page.templates.board.parse(data);
	page.templates.board.load(page.config.area.contents);
};

page.showBoard32 = function () {
	const data = {
		teams: page.data.teams,
		matches: page.data.matches.filter(m => m.group == null),
		stadiums: page.data.stadiums
	};

	page.templates.board32.parse(data);
	page.templates.board32.load(page.config.area.contents);
};

page.showBestThirds = function () {
	page.templates.bestThirds.parse(page.data.teams);
	page.templates.bestThirds.load(page.config.area.contents);
};

page.parseGroupRanking = function (from, group) {
	const g = group || from.charAt(1);
	const teams = page.data.teams.filter(t => t.group == g);
	page.templates.quickRanking.parse(teams, g, from.charAt(0));
};

page.getRankingPopup = function (from1, from2, g1, g2) {
	this.parseGroupRanking(from1, g1);
	this.parseGroupRanking(from2, g2);
	return page.templates.quickRanking.retrieve();
};

page.showPage = function (tplId, options) {
	const tpl = page.templates[tplId];
	tpl.parse(options);
	tpl.load(page.config.area.contents);
};

/**********************************************************/

window.addEventListener('load', function () {
	page.initialize();
});
window.addEventListener('unload', function () {
	page.destroy();
});
